<template>
  <div class="layer" style="background: #fff">
    <div class="blog-view">
      <h1>基于病毒学的情报分析数据集</h1>
      <div class="blog-sub">
        <span>中国工程科技知识中心</span>
        <span>2020-02-11 15:33:23</span>
      </div>
      <div class="blog-content">
        <p>浙江大学信息资源分析与应用中心结合中国工程院知识中心“工程科技机构与专家库”项目的数据建设成果，通过数据搜集与整理完成了基于病毒学的文献数据集以供学者分析与研究，数据集构建及说明如下。</p>
        <p>一、病毒学关键词获取</p>
        <p>检索Journal of General Virology、Journal of Virology、Virology、Advances in Experimental Medicine and Biology 、Emerging Infectious Diseases 五本病毒学及传染病学领域期刊2003-2020年文献，文献类型仅包含article和review，分析了52144篇文献数据共37876个关键词，用Bibexcel软件将关键词分行，统计词频，取词频大于等于13的关键词，筛选获得976个高频词，并生成共现关键词对，取共现次数大于等于5的关键词对共1046对。</p>
        <p>二、数据集构建</p>
        <p>以1046对关键词对为检索式，在Web of Science数据库275种医学权威期刊(期刊列表见附件)中检索标题、关键词和摘要字段，限定条件为2003-2018年文献类型为Article或Review的文献，命中文献322094篇。</p>
        <p>三、数据说明</p>
        <p>本中心对以上322094篇文献元数据进行了作者、机构、国别等信息的拆分，共获取1839840条作者机构信息。</p>
        <p>基于上述信息，我们发现2003年SARS之后，全球病毒学研究有一些统计学上的表现，其中发文排名前十的学者见表1。</p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/3658f277659f4fd0a3a7f3ec4f69a056" img_width="464" img_height="270" alt="基于病毒学的情报分析数据集" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p>利用荷兰莱顿大学科技研究中心(The Centre for Science and Technology Studies, CWTS)的van Eck 和Waltman于2009年开发的一款基于JAVA的免费软件VOSviewer，发文排名第一的作者“Haynes, Barton F.”的合作者网络如图1所示(注：并未显示所有合作者，VOSviewer对显示节点数要求在1000个左右)。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p3.pstatp.com/large/pgc-image/71152995de41477c8b9502d56b670a54" img_width="954" img_height="601" alt="基于病毒学的情报分析数据集" inline="0">
          <p class="pgc-img-caption article-img-caption">图1 Haynes, Barton F.的合作者网络</p>
        </div>
        <p>同时，发文排名第三的作者“Mascola, John R.”的合作者网络如图2所示，可以发现他和发文排名第一的“Haynes, Barton F.”、发文排名第二的“Montefiori, David C.”都有密切合作。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p3.pstatp.com/large/pgc-image/e330711bd46f4a8e97457f349970ea44" img_width="950" img_height="599" alt="基于病毒学的情报分析数据集" inline="0">
          <p class="pgc-img-caption article-img-caption">图2 Mascola, John R.的合作者网络</p>
        </div>
        <p>病毒学研究前10的研究机构见表2，可视化见图3。</p>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/082395edc97e4766be180491d7eaeb93" img_width="426" img_height="271" alt="基于病毒学的情报分析数据集" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p><br></p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/cac143e8f4a94973b5037983d7914e36" img_width="956" img_height="612" alt="基于病毒学的情报分析数据集" inline="0">
          <p class="pgc-img-caption article-img-caption">图3 全球病毒学机构合作网络分析</p>
        </div>
        <p>由上图可知，发文数量排名第一的哈佛大学与牛津大学、东京大学、墨尔本大学、中科院等机构有较为紧密的合作研究关系。</p>
        <p>全球病毒学研究的主要学者和机构分布国家列于表3。</p>
        <div class="pgc-img">
          <img src="http://p3.pstatp.com/large/pgc-image/b46944db17814fe7bffd0e32ba3496df" img_width="287" img_height="266" alt="基于病毒学的情报分析数据集" inline="0">
          <p class="pgc-img-caption"></p>
        </div>
        <p>其中，中国是发文排名第三的国家，其跨国合作网络分析如图4所示。</p>
        <div class="pgc-img">
          <img src="http://p1.pstatp.com/large/pgc-image/73d5ec0720a546deb682bfc093d81343" img_width="1152" img_height="654" alt="基于病毒学的情报分析数据集" inline="0">
          <p class="pgc-img-caption article-img-caption">图4 中国的跨国合作网络分析</p>
        </div>
        <p>上述数据集若机构与学者有需要进一步分析研究，可与知识中心机构与专家库课题组陆老师联系获取(gqlu@zju.edu.cn)。</p>
        <p>浙江大学信息资源分析与应用中心</p>
        <p>中国工程院知识中心中国工程科技机构与专家库课题组</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'blog1',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">
.blog-view{
  margin-top: 5vh;
  width: 50vw;
  .blog-sub{
    margin-top: 12px;
    margin-bottom: 20px;
    font-size: 13px;
    span{
      color: #777;
      margin-right: 2px;
    }
  }
  .blog-content{
    font-size: 16px;
    line-height: 28px;
    color: #222;
    word-wrap: break-word;
    p{
      margin-top: 16px;
      margin-bottom: 16px;
    }
    .pgc-img{
      font-size: 16px;
      line-height: 28px;
      color: #222;
      word-wrap: break-word;
      img{
        max-width: 100%;
        display: block;
        margin: 10px auto;
      }
      .article-img-caption{
        position: relative;
        margin-left: 10px;
        padding-left: 16px;
        text-align: center;
        font-size: 12px;
        line-height: 16px;
        color: #999;
      }
      .article-img-caption::before{
        content: "";
        position: relative;
        padding-left: 16px;
        text-align: center;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAAXNSR0IArs4c6QAAAZ9JREFUSA3llL9Kw1AUxvMHByGQFyi4pBBdM/gUYgZfQtDdxU3BUWgR3B0cdfEdHNwEUxqLqFOETm7553diGmhymp6rzaIXQnO/e8/59Zx7v2jaXx26amGTyWQjjuMt0zQfHcd5U4k3VDYHQXAM0HOe53dpmr6MRqMjlXhxZQDtIvENk9x3XfeW0RuSqLIoiixd14eNaAik0zq3VtdEsOl0eoLW9erBNCed1rm1ura0jWEYejifeyQ168GzOapLcWG2cWEeZhr321oZAZIkuWwDUVLpvlYYbtshcnncv2Q0r9zPLH1LC9s4Ho97aN8TtokOvyR8op2b/X7/nSMurCzLsoEiiPJbZRzH0lgY2uHjHHw2YolIcRTPbWvASs9QVb8ZA857DVibp6R0VMd6b+6CSDwlBXLeqyqTekUK4/JVMEVPSZlz3iva+ENPSYGV94rK4I1TRKqYVwqifRY+Dmf0YlBv8ezQpKuBy7IHxhpVhnd9vSsQ5QWIOJkBUIKXaxI7HFfgpMWZ2bZ9gMkFno8VA18NwzjHx3l/xXn/c7ovwH/SGRgoOLUAAAAASUVORK5CYII=) no-repeat 50%;
        background-size: cover;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/blog/blog1.vue